<template>
	<div>
		<el-tabs type="card" v-model="tagConfig">
			<el-tab-pane label="Config" name="tab-cadastro">
				<span slot="label">
					<i class="fa fa-list-alt"></i> Informações Cadastrais
				</span>

				<ed-form :data="formData" :config="config" :response="response" :itens="formItems">
					<div slot="form-footer"></div>
				</ed-form>
			</el-tab-pane>

			<el-tab-pane label="Config" name="tab-categoria" v-if="false">
				<span slot="label">
					<i class="fa fa-list-alt"></i> Gerenciar Categoria
				</span>

				<TabelaDinamicaCategoria :tabela="formData" v-if="formData.id>0"/>
			</el-tab-pane>

			<el-tab-pane label="Config" name="tab-colunas" v-if="boolExibir">
				<span slot="label">
					<i class="fa fa-columns"></i> Gerenciar Colunas
				</span>

				<TabelaDinamicaColuna :tabela="formData" v-if="formData.id>0"/>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>

	import Rest from 'common/rest'
	import EdForm from 'common/form'
	import FormItems  from './_form/tabela-cadastrar'
	import TabelaDinamicaColuna  from './coluna/index'
	import TabelaDinamicaCategoria  from './categoria/index'

  	export default {
  		name:"empresa",
  		components: {EdForm,TabelaDinamicaColuna,TabelaDinamicaCategoria},
  		mixins:[Rest],
  		data () {
		   	return {
				config:{
					click:{
						save:this.salvar,
					},
					loading:{
						save:false,
					},
					hidden:{
						copiar:true,
					}
				},
				response:{},
				formItems:[],
				formData:{
					id:this.$route.params.id,
				},
				boolExibir:false,
				tagConfig:'tab-cadastro'
			}
		},

		created(){
		},

		mounted() {
			this.formItems = FormItems;
			this.boolExibir = (
				[1,914].indexOf(this.$root.$session.cliente.logged.id) != -1 ||
				this.$root.$session.usuario.logged.usuario == 'SuporteSA'
			);
			this.getTabelaDinamica();
		},
		methods: {

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {

					self.config.loading.save = true;
					
                    self.delete('/ltcat/tabela-dinamica/deletar',{ids:data}).then((result)=>{
                        result = result[0];

                        self.config.loading.save = false;

                        if(result.status == 200){
							self.edMsg('Registo excluido com sucesso');
							self.getTabelaDinamica();
                        }
                    });

                });
			},

			getTabelaDinamica: function(){

				this.config.loading.save = true;
				this.response = {};

				this.get('/ltcat/tabela-dinamica/'+this.$route.params.id).then((result)=>{
           			result = result[0];

					this.config.loading.save = false;
					this.response = {};

					if(result.status == 200){
						this.formData ={
							id:result.data.id,
							nome:result.data.nome,
							cor:result.data.cor,
							obs:result.data.obs,
							ativo:result.data.ativo,
							updated_at:result.data.updated_at,
							usuario:result.data.usuario
						};
					}
	       });
			},

			salvar: function(){
				
				this.config.loading.save = true;
				this.response = {};

				this.post('/ltcat/tabela-dinamica/editar',this.formData).then((result)=>{

					result = result[0];
						
					this.config.loading.save = false;
					this.response = result;
					
					if(result.status == 200){
						this.edMsg('Dados atualizados')
						this.getTabelaDinamica();
					}
				});
			}

		}
  	}
</script>


// WEBPACK FOOTER //
// editar.vue?34761548